import React, { useEffect, useState } from "react";
import { Button, Checkbox, message } from "antd";
import { OPTION_OTHER } from "../../constants/constants";
import { Edit } from "@mui/icons-material";
import { Edit2Icon } from "lucide-react";

interface SingleSelectButtonGroupProps {
  label: string;
  options: string[];
  selected: string;
  setSelected: (selected: string) => void;
  checked: boolean;
  setChecked: (checked: boolean) => void;
  showCheckBox?: boolean;
  checkboxClassName?: string;
}

const SingleSelectButtonGroupWithAddItem: React.FC<SingleSelectButtonGroupProps> = ({
  label,
  options = [],
  selected,
  setSelected,
  checked,
  setChecked,
  showCheckBox = true,
  checkboxClassName,
}) => {
  const [isAddOther, setIsAddOther] = useState(false)
  const [otherValue, setOtherValue] = useState("")
  const [allOptions, setAllOptions] = useState<string[]>(options || [])


  useEffect(() => {
    if (options.includes(selected)) {
      setIsAddOther(false);
      setOtherValue("")
      setAllOptions(options);
    } else {
      if (selected) {
        setAllOptions([...options, selected])
      }

    }


  }, [selected])


  const onAdd = () => {
    if (otherValue) {
      setSelected(otherValue)
      setAllOptions([...allOptions, otherValue])
      setIsAddOther(false)
    } else {
      message.warning("Enter other value")
    }
  }

  const editCustom = () => {
    setIsAddOther(true)
    setAllOptions(prev => prev.filter(o => o !== otherValue))
  }

  return (
    <div className="col-span-1">
      {showCheckBox ? (
        <Checkbox
          checked={checked}
           onChange={(e) => {
            setChecked(e.target.checked)
            if (!e.target.checked) {
              setSelected("")
            }
          }}
          className="common-bold-label"
        >
          {label}
        </Checkbox>
      ) : (
        <p className="common-bold-label">{label}</p>
      )}

      {checked && (
        <div
          className={`flex flex-wrap gap-x-2 gap-y-2 mt-[24px] ${checkboxClassName}`}
        >
          {allOptions?.filter((o: string) => o !== OPTION_OTHER)?.map((option) => (
            <Button
              type="text"
              key={option}
              onClick={() => setSelected(option)}
              className={`cursor-pointer rounded-[30px] px-5 py-1 text-sm font-normal font-['Inter'] leading-tight transition flex items-center gap-2 ${selected === option ? "text-[#1849a9]" : "text-[#1d2939]"
                }`}
              style={{
                border: `1px solid ${selected === option ? "#53b1fd" : "#e4e7ec"
                  }`,
                backgroundColor: `${selected === option ? "#d1e9ff" : ""}`,
              }}
            >
              {selected === option && (
                <span className="h-2 w-2 bg-[#1849a9] rounded-full" />
              )}
              {option}
              {option === otherValue && option ? (
                <Button icon={<Edit2Icon size={12} />} type="text" size="small" shape="circle" onClick={() => editCustom()} />
              ) : (
                <></>
              )}

            </Button>
          ))}
          {
            isAddOther ? (
              <div
                className="flex items-center"
              >
                <input
                  type="text"
                  value={otherValue}
                  onChange={(e) => setOtherValue(e.target.value)}
                  placeholder="Enter custom option"
                  className="px-3 py-1 border border-gray-300 rounded-l-full text-sm focus:outline-none h-[32px]"
                  autoFocus
                />
                <Button
                  htmlType="submit"
                  className="rounded-r-full common-primary-button"
                  onClick={() => onAdd()}
                >
                  Add
                </Button>
              </div>
            ) : (
              allOptions.includes(OPTION_OTHER) && !allOptions.includes(otherValue) ? (
                <Button
                  type="text"
                  key={"other"}
                  onClick={() => setIsAddOther(!isAddOther)}
                  className={`cursor-pointer rounded-[30px] px-5 py-1 text-sm font-normal font-['Inter'] leading-tight transition flex items-center gap-2 ${isAddOther ? "text-[#1849a9]" : "text-[#1d2939]"
                    }`}
                  style={{
                    border: `1px solid ${isAddOther ? "#53b1fd" : "#e4e7ec"
                      }`,
                    backgroundColor: `${isAddOther ? "#d1e9ff" : ""}`,
                  }}
                >
                  {isAddOther && (
                    <span className="h-2 w-2 bg-[#1849a9] rounded-full" />
                  )}
                  Other
                </Button>
              ) : (
                <></>
              )
            )
          }
        </div>
      )}
    </div>
  );
};

export default SingleSelectButtonGroupWithAddItem;
